module.exports = __webpack_public_path__ + "img/pic5.ef7023e4.png";